import React from 'react';
import { Check, Shield, Star, ShieldCheck, Headphones, BookOpen, Book, Sparkles } from 'lucide-react';
import { Button } from './Button';
import { useCurrency } from '../../hooks/useCurrency';
interface PurchaseCardProps {
  title?: string;
  subtitle?: string;
  className?: string;
  featured?: boolean;
}
export function PurchaseCard({
  title = 'YO SOY una mujer que atrae',
  subtitle = 'Comienza a Manifestar la Vida que Mereces',
  className = '',
  featured = false
}: PurchaseCardProps) {
  const checkoutUrl = 'https://buy.stripe.com/fZu3cvfpHf868h42kfefC07';
  const goToCheckout = () => {
    window.open(checkoutUrl, '_blank');
  };
  const {
    formatPrice,
    formatPriceParts,
    currency
  } = useCurrency();
  const priceParts = formatPriceParts(19.99);
  return <div className={`relative overflow-hidden bg-white rounded-[2rem] p-8 md:p-10 shadow-2xl border border-[#C9A86A]/10 transition-all duration-500 hover:shadow-[0_30px_60px_-12px_rgba(201,168,106,0.25)] ${className}`} data-id="element-236">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF7F5]/50 to-transparent pointer-events-none" data-id="element-237" />

      {featured && <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#C9A86A] via-[#D4A5A5] to-[#C9A86A]" data-id="element-238" />}

      <div className="relative z-10 flex flex-col items-center text-center" data-id="element-239">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-[#C9A86A] to-[#D4A5A5] text-white text-xs font-bold uppercase tracking-widest shadow-lg mb-6 animate-pulse" data-id="element-240">
          <Star className="w-3 h-3 fill-current" data-id="element-241" />
          Promo 50% de Descuento
        </div>

        {/* Title */}
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#3A3A3A] mb-2 leading-tight" data-id="element-242">
          {title}
        </h3>
        <p className="text-gray-500 mb-6 max-w-sm mx-auto" data-id="element-243">{subtitle}</p>

        {/* What You Get List */}
        <div className="w-full bg-[#FAF7F5] rounded-xl p-4 mb-6 border border-[#E8D5D0]/50" data-id="element-244">
          <ul className="space-y-2 text-left text-sm text-[#3A3A3A] font-medium" data-id="element-245">
            <li className="flex items-center gap-2" data-id="element-246">
              <Headphones className="w-4 h-4 text-[#C9A86A]" data-id="element-247" />
              <span data-id="element-248">Audio guiado mientras duermes</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-249">
              <BookOpen className="w-4 h-4 text-[#C9A86A]" data-id="element-250" />
              <span data-id="element-251">Ebook completo</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-252">
              <Book className="w-4 h-4 text-[#C9A86A]" data-id="element-253" />
              <span data-id="element-254">Cuaderno de ejercicios</span>
            </li>
          </ul>
        </div>

        {/* Pricing - Apple Style */}
        <div className="flex items-end justify-center gap-3 mb-4" data-id="element-255">
          <div className="flex flex-col items-end mb-2" data-id="element-256">
            <span className="text-lg text-gray-400 line-through font-medium decoration-gray-300" data-id="element-257">
              {formatPrice(39.99)}
            </span>
            <span className="text-[10px] text-gray-400 font-bold uppercase tracking-wider" data-id="element-258">
              {currency.code}
            </span>
          </div>

          <div className="flex items-start leading-none text-[#3A3A3A] font-sans" style={{
          letterSpacing: '-0.04em'
        }} data-id="element-259">
            <span className="text-4xl font-light mt-2" data-id="element-260">
              {priceParts.symbol}
            </span>
            <span className="text-7xl md:text-8xl font-light" data-id="element-261">
              {priceParts.whole}
            </span>
            {priceParts.decimal && <div className="flex flex-col justify-start mt-2" data-id="element-262">
                <span className="text-4xl font-light" data-id="element-263">
                  {priceParts.decimal}
                </span>
              </div>}
          </div>
        </div>

        {/* Guaranteed Purchase Banner */}
        <div className="flex items-center justify-center gap-2 mb-6 px-5 py-2.5 rounded-xl bg-gradient-to-r from-[#C9A86A]/10 to-[#D4A5A5]/10 border border-[#C9A86A]/20 w-full" data-id="element-264">
          <ShieldCheck className="w-5 h-5 text-[#C9A86A] flex-shrink-0" data-id="element-265" />
          <span className="text-sm font-semibold text-[#3A3A3A]" data-id="element-266">
            Compra garantizada — 7 días de devolución
          </span>
        </div>

        {/* CTA */}
        <Button onClick={goToCheckout} fullWidth variant="luxury" withSparkle className="text-lg py-5 mb-6 shadow-xl" data-id="element-267">
          ACCESO INMEDIATO
        </Button>

        {/* Guarantee */}
        <div className="flex items-center justify-center gap-2 text-xs text-gray-500 bg-[#FAF7F5] px-4 py-2 rounded-full border border-[#E8D5D0]/50" data-id="element-268">
          <Shield className="w-3 h-3 text-[#C9A86A]" data-id="element-269" />
          <span data-id="element-270">Garantía de 7 días sin riesgo</span>
        </div>

        {/* Features */}
        <div className="mt-8 pt-8 border-t border-[#E8D5D0]/50 w-full" data-id="element-271">
          <ul className="space-y-3 text-left max-w-xs mx-auto" data-id="element-272">
            {['Acceso inmediato al programa', '5 Bonos exclusivos incluidos', 'Actualizaciones de por vida', 'Soporte prioritario', 'Disponible desde cualquier país'].map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-600" data-id="element-273">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#C9A86A]/10 flex items-center justify-center mt-0.5" data-id="element-274">
                  <Check className="w-3 h-3 text-[#C9A86A]" data-id="element-275" />
                </div>
                {feature}
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}